import { Base } from 'active-resource';
import { EmployerInterviewEventTypeResource } from 'util/resources/EmployerInterviewEventType';
import { EmployerProfileResource } from 'util/resources/EmployerProfile';
import { UserProfileResource } from 'util/resources/UserProfile';
import APILibrary, { ClassExtender, GConstructor, GenerateResource } from './APILibrary';

/**
 * Relationship classes
 */
export class InterviewAttributes {
  createdAt: string = null;
  id: string = null;
  interviewEventTypeId: string = null;
  employerProfileId: string = null;
  status: string = null;
  time: string = null;
  updatedAt: string = null;
  instructions: Record<string, string> = null;
  canceledByType: string = null;
}

export class InterviewBelongsTo {
  employerProfile: () => EmployerProfileResource = () => new EmployerProfileResource();
  userProfile: () => UserProfileResource = () => new UserProfileResource();
  interviewEventType: () => EmployerInterviewEventTypeResource = () =>
    new EmployerInterviewEventTypeResource();
}

export class InterviewHasOne {}
export class InterviewHasMany {}

/**
 * Utility interfaces
 */
export interface InterviewMethods {}

export interface InterviewInterface
  extends InterviewAttributes,
    InterviewBelongsTo,
    InterviewHasOne,
    InterviewHasMany,
    InterviewType {}

type InterviewType = GConstructor<InterviewInterface>;

export interface InterviewResource
  extends Base<InterviewAttributes>,
    InterviewInterface,
    InterviewMethods {}

/**
 * Resource methods
 */
const BaseClass = () =>
  GenerateResource<InterviewAttributes>({
    queryName: 'interviews',
    className: 'Interview',
    AttributesClass: InterviewAttributes,
    BelongsToClasses: [
      {
        Klass: InterviewBelongsTo,
      },
    ],
    HasOneClasses: [
      {
        Klass: InterviewHasOne,
      },
    ],
    HasManyClasses: [
      {
        Klass: InterviewHasMany,
      },
    ],
  });

export const InterviewResourceClass = <TBase extends InterviewType>(
  BaseConstructor: TBase,
): TBase => class extends BaseConstructor implements InterviewMethods {};

export class InterviewResource extends ClassExtender<InterviewInterface>(
  BaseClass,
  InterviewResourceClass,
) {}

/**
 * Resource instance
 */
export const Interview = APILibrary.createResource<InterviewResource>(InterviewResource);
